import {
    IonPage, IonContent, IonAlert, IonInput
} from '@ionic/react';
import React, {Component} from "react";
import './css/PoneAccountRefund.css';
import {faceVerifyLogQuery, SendSmsCodeSlider} from "./Service";
import {withRouter} from "react-router-dom";
import Script from "react-load-script";
import {captchaKeFuAppId, captchaUrl} from "../../../utils/common";


class PhoneAccountRefundCheck extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isH5: true,
            resultShow: false,
            isShowTip: false,
            showTipMsg: null,
            phone: null,
            accounts: '',
            code: null,
            getCodeMsg: "获取验证码",
            smsType: 23,
            refundLogList: {
                'sysId': 0,
                'userGameId': 0,
                'applyStatus': 0,  //0,审核中，1：审核成功，2：审核失败
                'failReason': '',
                'addTime': '',
            }
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)

    handleScriptError = () => {
        this.setShowTipModal('组件加载失败')
    }
    handleScriptLoad = () => {
        this.setState({
            scriptLoaded: true,
        });
    }

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null,
        })
    }

    /**
     * 图片滑块+短信发送+结果查询
     * @param par
     */
    showView = (par) => {
        const {accounts, phone, code, getCodeMsg, smsType, isH5} = this.state;
        if (par != 'getUserInfo' && "获取验证码" !== getCodeMsg) {
            return;
        }

        if (accounts === "") {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入游戏账号或者ID'
            })

            return;
        }

        if (!this.regPhone.test(phone)) {

            this.setState({
                isShowTip: true,
                showTipMsg: '请输入正确的手机号码'
            })

            return false;
        }

        const _that = this;

        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {
            console.log(res)
            if (res.ret === 0) {

                const urlParms = {
                    'accounts': accounts,
                    'phone': phone,
                    'ticket': res.ticket,
                    'randStr': res.randstr,
                }

                if (par === 'getUserInfo') {

                    if (!_that.regCode.test(code)) {

                        _that.setState({
                            isShowTip: true,
                            showTipMsg: '请输入正确的验证码'
                        })

                        return false;
                    }

                    urlParms.smsCode = code;
                    console.log(urlParms);
                    faceVerifyLogQuery(urlParms, isH5).then(ret => {
                        if (ret.code === '10000') {
                            console.log(ret.data);
                            const refundLogList = ret.data[0];
                            _that.setState({
                                resultShow: true,
                                refundLogList: refundLogList
                            })
                        } else {
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                        }
                        captcha1.destroy();
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });

                } else {

                    urlParms.stype = smsType;

                    SendSmsCodeSlider(urlParms, isH5).then(ret => {
                        captcha1.destroy();
                        if (ret.code === '10000') {
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: '验证码已发送，请注意查收'
                            })
                            let djs = 60;
                            let aa = '';
                            let timeout = setInterval(function () {
                                djs--;
                                aa = (djs === 0) ? '获取验证码' : (djs + 's');
                                if (djs === 0 || djs < 0) {
                                    clearInterval(timeout);
                                }
                                _that.setState({djs: djs, getCodeMsg: aa})
                            }, 999)
                        } else {

                            _that.setState({
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                        }
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });
                }
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});

        captcha1.show(); // 显示验证码
    }


    render() {
        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont">
                        <div className="top_refund pr">
                            <a className="return-refund" href="/h5accountRefund">
                                <img src={require("../../images/member/refund/return_icon.png")} alt=""/>
                            </a>
                            <div className="top_title">申诉退款进度查询</div>
                        </div>
                        <div className="cont-refund">
                            <Script
                                url={captchaUrl()}
                                onError={this.handleScriptError}
                                onLoad={this.handleScriptLoad}
                            />
                            <div className="Input_box_refund">
                                <div className="identity clearfix">
                                    <span className="w246">游戏账号</span>
                                    <IonInput type="text" className="input-tex-refund"
                                              value={this.state.accounts}
                                              placeholder="请填写游戏账号"
                                              onIonChange={e => this.setState({accounts: e.detail.value})}/>
                                </div>
                                <div className="identity clearfix">
                                    <span className="w246">手机号码</span>
                                    <IonInput type="text" className="input-tex-refund"
                                              value={this.state.phone}
                                              placeholder="请填写申请时预留的手机号"
                                              onIonChange={e => this.setState({phone: e.detail.value})}/>
                                </div>
                                <div className="identity clearfix">
                                    <span className="w246">短信验证码</span>
                                    <IonInput type="text" className="input-tex2"
                                              value={this.state.code}
                                              placeholder="请输入短信验证码"
                                              onIonChange={e => this.setState({code: e.detail.value})}/>
                                    <input onClick={() => this.showView('sendsms')} id="btn_submit"
                                           value={this.state.getCodeMsg} type="button" className="input-button_refund_phone"/>
                                </div>
                                <a onClick={() => this.showView('getUserInfo')} className="btn-refund mt30">查看申诉结果</a>
                            </div>
                            {/* <!------------申诉进度3种结果----------------->*/}
                            {this.state.resultShow &&
                                <div>
                                    {this.state.refundLogList.applyStatus === 0 &&
                                        <div className="results_box_refund">
                                            <div className="results_img">
                                                <img src={require("../../images/member/refund/proces_img.jpg")} alt=""/>
                                            </div>
                                            <div className="resu_cont_refund">
                                                <p><em>申诉状态：</em><span className="cl_tex">审核处理中</span></p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.refundLogList.applyStatus === 1 &&
                                        <div className="results_box_refund">
                                            <div className="results_img">
                                                <img src={require("../../images/member/refund/successful_img.jpg")}
                                                     alt=""/>
                                            </div>
                                            <div className="resu_cont_refund">
                                                <p><em>申诉状态：</em><span className="cg_tex">审核成功</span></p>
                                                <p dangerouslySetInnerHTML={{__html: '<em>申诉处理结果：</em>'+this.state.refundLogList.failReason}}></p>
                                                <p><em>申诉处理时间：</em>{this.state.refundLogList.addTime}</p>
                                            </div>
                                        </div>
                                    }
                                    {this.state.refundLogList.applyStatus === 2 &&
                                        <div className="results_box_refund">
                                            <div className="results_img">
                                                <img src={require("../../images/member/refund/failure_img.jpg")}
                                                     alt=""/>
                                            </div>
                                            <div className="resu_cont_refund">
                                                <p><em>申诉状态：</em><span className="sb_tex">审核失败</span></p>
                                                <p dangerouslySetInnerHTML={{__html: '<em>申诉处理结果：</em>'+this.state.refundLogList.failReason}}></p>
                                                <p><em>申诉处理时间：</em>{this.state.refundLogList.addTime}</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
};

export default withRouter(PhoneAccountRefundCheck);
